import { NewUserQuest } from '@src/data/types';
import { useNewUserQuests } from '@src/hooks/useQuests';
import { VStack, Text, HStack } from 'ui_2';
import { NewUserQuestRow, NewUserQuestRowView } from './NewUserQuestRow';
import { useReferralRewardQuest } from '@src/hooks/useReferrals';

export const NewUserQuests = () => {
  const { data } = useNewUserQuests();

  const { data: referralRewardQuest } = useReferralRewardQuest();

  const quests = data?.quests;
  const completedAll =
    data?.completedAll &&
    (referralRewardQuest ? referralRewardQuest.completed : true);

  if (!quests || quests.length === 0 || completedAll === undefined) {
    return null;
  }

  const questsToShow = referralRewardQuest
    ? [...quests, referralRewardQuest]
    : quests;

  return (
    <HStack className='w-full justify-center sm:justify-center'>
      <VStack className='w-full max-w-[500px] gap-3 rounded-[10px] border border-gray-50 p-3'>
        <Text font='bold-sm'>Get started</Text>
        <VStack className='w-full gap-2'>
          {completedAll === false ? (
            questsToShow.map((quest: NewUserQuest, index) => (
              <NewUserQuestRow newUserQuest={quest} key={index} />
            ))
          ) : (
            <HStack className='w-full max-w-[500px] items-stretch gap-2'>
              <div className={`flex-grow py-1`}>
                <NewUserQuestRowView
                  completed={true}
                  inProgress={false}
                  title='You completed all the tasks! Congratulations!'
                />
              </div>
            </HStack>
          )}
        </VStack>
      </VStack>
    </HStack>
  );
};
